export default __webpack_public_path__ + "static/media/icon-logout-actived.0e7980cd.svg";